import type { ItemsPerPageOptionsType } from './pagination/pagination.types';

export const DEFAULT_ITEMS_PER_PAGE_OPTIONS: ItemsPerPageOptionsType = [10, 20, 50];

export const PAGINATION_PAGES_LIMIT = 9;

export const PAGINATION_PAGES_BUFFER = 2;

/** Separator string displayed between page numbers when truncating */
export const SEPARATOR = '...';
